// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-single_checkbox__pOtvZ","label":"checkbox-single_label__G5BM2","compact":"checkbox-single_compact__eNNxg","asterisk":"checkbox-single_asterisk__gY-v3"};